export default function LegalNoticePage() {
    return (
        <div className="container -legalPages main">
            <div className="row">
                <div className="col-md-8 offset-md-2">
                    <div className="row d-flex justify-content-center">
                        <h2 className="header">
                            Legal Notice
                        </h2>
                    </div>
                    <br />
                    <div className="row d-flex">
                        <h4 className="pt-3">COMPANY NAME</h4>
                        <p>
                            Further Corporation Limited
                        </p>
                        <h4 className="pt-3">ADDRESS</h4>
                        <p>
                            Aldgate Tower, 2 Leman Street, London E18QN, United Kingdom<br />
                            Email: info [at] further.network<br />
                            Phone: <br />
                            Websiste: <a href="https://further.network" target="_blank">https://further.network</a>
                        </p>
                        <h4 className="pt-3">COMPANY REGISTRATION</h4>
                        <p>
                            Further Corporation Limited is registered in the Companies House under the Registration Number
                            11283866
                        </p>
                        <h4 className="pt-3">MANAGING DIRECTOR</h4>
                        <p>
                            Kadir Ozgur Oguz<br />
                            Email: koguz@further.network
                        </p>
                        <p>
                            For the EU citizens The European Commission provides a platform for online dispute resolution. You can
                            find this platform at https://ec.europa.eu/consumers/odr/. In case of complaints, please contact
                            furtherpass@furtherpass.com
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}